export default {
	0: "Disabled",
	1: "Enabled"
};
